export default "__VITE_ASSET__D61e6wU1__"